module.exports = __webpack_public_path__ + "img/hdmi2csi.a5181a3c.png";